/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Accordion, Button, Col, Container, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import errorHandler from '../../../../support_func/errorHandler';
import unavailable from '../../../../support_func/unavailable';

const FirmwareManagement = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem('autoAcceso');
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const [firmwares, setFirmwares] = useState([]);
  const [placaversions, setPlacaversions] = useState([]);
  const [availablePlacaversions, setAvailablePlacaversions] = useState([]);
  const [placaData, setPlacaData] = useState({});
  const [data, setData] = useState({});
  const [file, setFile] = useState(null);
  const [key, setKey] = useState(0);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const toggleFirmwarePlacaversion = (idplacaversion) => {
    const current = data.idplacaversions || [];

    if (current.includes(idplacaversion)) {
      setData({
        ...data,
        idplacaversions: current.filter((id) => id !== idplacaversion),
      });
    } else {
      setData({
        ...data,
        idplacaversions: [...current, idplacaversion],
      });
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setFile(files[0]);
    }
  };

  const UploadFirmware = async (e) => {
    e.preventDefault();
    setIsPending(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('version', data.version);
   // formData.append('v_ghator', data.v_ghator);
    (data.idplacaversions || []).forEach((idplacaversion) => {
      formData.append('idplacaversions[]', idplacaversion);
    });
    if (!data.idplacaversions || data.idplacaversions.length === 0) {
      setIsPending(false);
      setError(t('warnSelectDeviceV'));
      return;
    }
    formData.append('date', moment(data.date).format('DD-MM-yyyy'));
    formData.append('mandatory', data.mandatory ? true : false);
    formData.append('checksum', data.checksum || '');
    formData.append('size_bytes', data.size_bytes || '');
    formData.append('release_notes', data.release_notes || '');

    axios
      .post(`${process.env.REACT_APP_API_SRT}/v3/uploadfirm`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        if (!res.data.code) {
          unavailable(true);
        }
        if (res.data.code === '0') {
          //setData({});
          setData({
            idplacaversions: [],
          });
          setFile(null);
          setKey(key + 1);
          getFirmwares(true);
        } else {
          setIsPending(false);
          setError(t('problem'));
        }
        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const getFirmwares = (added) => {
    setIsPending(true);
    axios
      .get(`${process.env.REACT_APP_API_SRT}/v3/availablefirm`, config)
      .then((res) => {
        console.log(res.data);
        if (!res.data.code) {
          unavailable(true);
        }
        if (res.data.code === '0') {
          setFirmwares(res.data.firmwares);
          added && setError(t('uploaded') + ' ' + t('success'));
          setIsPending(false);
        } else {
          setIsPending(false);
          setError(t('problem'));
        }
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const patchFirmware = (firm) => {
    const idplacaversions = (firm.placaversions || []).map((placa) => placa.id);

    if (idplacaversions.length === 0) {
      setError(t('warnSelectDeviceV'));
      return;
    }

    setIsPending(true);

    axios
      .patch(
        `${process.env.REACT_APP_API_SRT}/v3/patchfirm`,
        {
          idfirmversion: firm.id,
          date: moment(firm.date).format('DD-MM-yyyy'),
          idplacaversions: idplacaversions,
          mandatory: firm.mandatory ? true : false,
          checksum: firm.checksum || '',
          size_bytes: firm.size_bytes || '',
          release_notes: firm.release_notes || '',
        },
        config
      )
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          setError(t('firmware') + ' ' + t('updated') + ' ' + t('success'));
          getFirmwares();
        } else {
          setError(t('problem'));
        }

        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const delFirmware = (version) => {
    setIsPending(true);
    axios
      .delete(`${process.env.REACT_APP_API_SRT}/v3/delfirm`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { versions: [version] },
      })
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }
        if (res.data.code === '0') {
          console.log(res.data);
          setError(t('firmware') + ' ' + t('deleted') + ' ' + t('success'));
          getFirmwares();
          setIsPending(false);
        } else {
          setIsPending(false);
          setError(t('problem'));
        }
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const getPlacaversions = () => {
    setIsPending(true);
    axios
      .get(`${process.env.REACT_APP_API_SRT}/private2/placaversionget`, config)
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          setPlacaversions(res.data.placaversions);
        } else {
          setError(t('problem'));
        }

        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const getAvailablePlacaversions = () => {
    axios
      .get(`${process.env.REACT_APP_API_SRT}/private2/placaversionavailableget`, config)
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          setAvailablePlacaversions(res.data.placaversions);
        } else {
          setError(t('problem'));
        }
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const createPlacaversion = (e) => {
    e.preventDefault();

    setIsPending(true);

    axios
      .post(
        `${process.env.REACT_APP_API_SRT}/private2/placaversionpost`,
        {
          version: placaData.version,
          name: placaData.name,
          description: placaData.description,
        },
        config
      )
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          setError(t('vIdri') + ' ' + t('created') + ' ' + t('success'));

          setPlacaData({});

          getPlacaversions();
          getAvailablePlacaversions();
        } else {
          setError(t('problem'));
        }

        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const delPlacaversion = (idplacaversion) => {
    setIsPending(true);

    axios
      .delete(`${process.env.REACT_APP_API_SRT}/private2/placaversiondel`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          idplacaversions: [idplacaversion],
        },
      })
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          const deleted = res.data.deleted || [];
          const notDeleted = res.data.not_deleted || [];

          if (deleted.length > 0 && notDeleted.length === 0) {
            setError(t('vIdri') + ' ' + t('deleted') + ' ' + t('success'));
          } else if (deleted.length === 0 && notDeleted.length > 0) {
            setError(`the board version could not be deleted: ${notDeleted[0].reason}`);
          } else if (deleted.length > 0 && notDeleted.length > 0) {
            setError('some board versions have been erased and others have not');
          } else {
            setError('no board version has been deleted');
          }

          getPlacaversions();
          getAvailablePlacaversions();
        } else {
          setError(t('problem'));
        }

        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const patchPlacaversion = (placa) => {
    setIsPending(true);

    axios
      .patch(
        `${process.env.REACT_APP_API_SRT}/private2/placaversionpatch`,
        {
          idplacaversion: placa.id,
          name: placa.name,
          description: placa.description,
          active: placa.active,
        },
        config
      )
      .then((res) => {
        if (!res.data.code) {
          unavailable(true);
        }

        if (res.data.code === '0') {
          setError(t('vIdri') + ' ' + t('updated') + ' ' + t('success'));
          getPlacaversions();
        } else {
          setError(t('problem'));
        }

        setIsPending(false);
      })
      .catch((error) => {
        errorHandler(error, setIsPending, setError);
      });
  };

  const updatePlacaversionField = (id, field, value) => {
    setPlacaversions((prev) =>
      prev.map((placa) =>
        placa.id === id
          ? {
              ...placa,
              [field]: value,
            }
          : placa
      )
    );
  };

  const updateFirmwareField = (id, field, value) => {
    setFirmwares((prev) =>
      prev.map((firm) =>
        firm.id === id
          ? {
              ...firm,
              [field]: value,
            }
          : firm
      )
    );
  };

  const toggleAvailableFirmwarePlacaversion = (idfirmversion, placaversion) => {
    setFirmwares((prev) =>
      prev.map((firm) => {
        if (firm.id !== idfirmversion) return firm;

        const currentPlacaversions = firm.placaversions || [];
        const exists = currentPlacaversions.some((p) => p.id === placaversion.id);

        return {
          ...firm,
          placaversions: exists
            ? currentPlacaversions.filter((p) => p.id !== placaversion.id)
            : [...currentPlacaversions, placaversion],
        };
      })
    );
  };

  useEffect(() => {
    getFirmwares();
    getPlacaversions();
    getAvailablePlacaversions();
  }, []);

  useEffect(() => {
    error !== null && window.alert(error);
    setError(null);
  }, [error]);

  return (
    <Container className='text'>
      {isPending && (
        <div className='working_apis'>
          <div className='text-working-apis'>{t('comprobando')}...</div>
        </div>
      )}
      <Accordion defaultActiveKey='0' className='acc' alwaysOpen>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center'>
                  <th colSpan={2} className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>
                      {t('deviceVersionManage')}
                    </p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>

          <Accordion.Body>

            <Form onSubmit={createPlacaversion}>
              <Row className='px-0'>

                <Col xs={12} md={4}>
                  <strong>{t('deviceVersion')}</strong>

                  <Form.Select
                    required
                    value={placaData.version || ''}
                    onChange={(e) =>
                      setPlacaData({
                        ...placaData,
                        version: e.target.value,
                      })
                    }
                  >
                    <option value=''>{t('selecVersion')}</option>

                    {availablePlacaversions.map((version) => (
                      <option key={version} value={version}>
                        {version}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('nombre')}</strong>

                  <Form.Control
                    type='text'
                    value={placaData.name || ''}
                    onChange={(e) =>
                      setPlacaData({
                        ...placaData,
                        name: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('Description')}</strong>

                  <Form.Control
                    type='text'
                    value={placaData.description || ''}
                    onChange={(e) =>
                      setPlacaData({
                        ...placaData,
                        description: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col xs={12} md={2} className='d-grid mt-2 mt-md-4'>
                  <Button type='submit'>
                    {t('create')}
                  </Button>
                </Col>

              </Row>
            </Form>

            <hr />

            {placaversions.map((placa) => (
              <Row key={placa.id} className='px-0 mb-3'>

                <Col xs={12} md={2}>
                  <strong>{t('version')}</strong>

                  <Form.Control
                    readOnly
                    value={placa.version || ''}
                  />
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('nombre')}</strong>

                  <Form.Control
                    value={placa.name || ''}
                    onChange={(e) =>
                      updatePlacaversionField(
                        placa.id,
                        'name',
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col xs={12} md={3}>
                  <strong>{t('Description')}</strong>

                  <Form.Control
                    value={placa.description || ''}
                    onChange={(e) =>
                      updatePlacaversionField(
                        placa.id,
                        'description',
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col xs={12} md={2}>
                  <strong>{t('activado')}</strong>

                  <Form.Check
                    type='checkbox'
                    checked={placa.active || false}
                    onChange={(e) =>
                      updatePlacaversionField(
                        placa.id,
                        'active',
                        e.target.checked
                      )
                    }
                  />
                </Col>

                <Col xs={12} md={1} className='d-grid mt-2 mt-md-4'>
                  <Button
                    onClick={() => patchPlacaversion(placa)}
                  >
                    {t('save')}
                  </Button>
                </Col>

                <Col xs={12} md={1} className='d-grid mt-2 mt-md-4'>
                  <Button
                    className='dark'
                    onClick={() =>
                      window.confirm('¿borrar versión de placa?')
                        ? delPlacaversion(placa.id)
                        : null
                    }
                  >
                    {t('deleteG')}
                  </Button>
                </Col>

              </Row>
            ))}

          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey='1'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center'>
                  <th colSpan={2} className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>{t('uploadFile')}</p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>
          <Accordion.Body>
            <Form onSubmit={UploadFirmware}>
              <Row className='px-0'>
                <Col xs={12} md={4}>
                  <strong className=''>{t('firmVersion')}<sup className='text-danger'>*</sup></strong>                  
                  <Form.Control
                    required
                    type='text'
                    value={data.version ? data.version : ''}
                    onChange={(e) =>
                      setData({
                        ...data,
                        version: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col xs={12} md={4}>
                  <strong>{t('CompatibleBoards')}<sup className='text-danger'>*</sup></strong>

                  <div className='border rounded px-3 py-2' style={{ minHeight: '55px' }}>
                    {placaversions.length === 0 && (
                      <span className='text-muted'>No hay versiones de placa creadas</span>
                    )}

                    {placaversions.map((placa) => (
                      <Form.Check
                        key={placa.id}
                        inline
                        type='checkbox'
                        label={placa.version}
                        checked={(data.idplacaversions || []).includes(placa.id)}
                        onChange={() => toggleFirmwarePlacaversion(placa.id)}
                      />
                    ))}
                  </div>
                </Col>
                {/* <Col xs={12} md={4}>
                  <strong className=''>{t('deviceVersion')}</strong>
                  <Form.Control
                    required
                    type='text'
                    value={data.v_ghator ? data.v_ghator : ''}
                    onChange={(e) =>
                      setData({
                        ...data,
                        v_ghator: e.target.value,
                      })
                    }
                  />
                </Col> */}
                <Col xs={12} md={4}>
                  <strong className=''>{t('firmDate')}<sup className='text-danger'>*</sup></strong>
                  <DatePicker
                    required
                    locale={localStorage.getItem('language')}
                    customInput={<Form.Control />}
                    dateFormat='dd-MM-yyyy'
                    selected={data.date ? data.date : ''}
                    onChange={(date) =>
                      setData({
                        ...data,
                        date: date,
                      })
                    }
                    maxDate={moment()._d}
                    withPortal
                  />
                </Col>
                <Col xs={12} md={2}>
                  <strong>{t('mandatory')}</strong>
                  <Form.Check
                    type='checkbox'
                    checked={data.mandatory || false}
                    onChange={(e) =>
                      setData({
                        ...data,
                        mandatory: e.target.checked,
                      })
                    }
                  />
                </Col>

                <Col xs={12} md={3}>
                  <strong>checksum</strong>
                  <Form.Control
                    type='text'
                    value={data.checksum || ''}
                    onChange={(e) =>
                      setData({
                        ...data,
                        checksum: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col xs={12} md={2}>
                  <strong>{t('sizebytes')}</strong>
                  <Form.Control
                    type='number'
                    value={data.size_bytes || ''}
                    onChange={(e) =>
                      setData({
                        ...data,
                        size_bytes: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col xs={12}>
                  <strong>{t('releaseNotes')}</strong>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    value={data.release_notes || ''}
                    onChange={(e) =>
                      setData({
                        ...data,
                        release_notes: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col xs={12}>
                  <strong className=''>{t('selectFile')}:<sup className='text-danger'>*</sup></strong>
                  <InputGroup>
                    <Form.Control
                      required
                      type='file'
                      className=''
                      key={key}
                      onChange={handleFileChange}
                    />
                    <Button disabled={!file} variant='primary' className='' type='submit'>
                      {t('upload').toUpperCase()}
                    </Button>
                  </InputGroup>
                </Col>
              </Row>
            </Form>
            <div className='text-end mt-2'>
              <small className='text-muted fst-italic'>
                {t('requiredFields')}
                <sup className='text-danger'>*</sup>
              </small>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey='2'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center'>
                  <th colSpan={2} className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>{t('availableFirmwares')}</p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>
          <Accordion.Body>
            {firmwares.map((firm, i) => (
              <React.Fragment key={firm.id || firm.version}>
                {i > 0 && <hr className='hr-dark d-block d-md-none mt-2 mb-0' />}

                <Row className='px-0 mb-3'>
                  <Col xs={12} md={2}>
                    <strong className=''>{t('firmVersion')}</strong>
                    <Form.Control readOnly type='text' value={firm.version || ''} />
                  </Col>

                  <Col xs={12} md={3}>
                    <strong className=''>{t('firmDate')}</strong>
                    <DatePicker
                      locale={localStorage.getItem('language')}
                      customInput={<Form.Control />}
                      dateFormat='dd-MM-yyyy'
                      selected={firm.date ? moment(firm.date)._d : ''}
                      onChange={(date) =>
                        updateFirmwareField(
                          firm.id,
                          'date',
                          date
                        )
                      }
                      maxDate={moment()._d}
                      withPortal
                    />
                  </Col>

                  <Col xs={12} md={4}>
                    <strong>{t('CompatibleBoards')}</strong>

                    <div className='border rounded px-3 py-2' style={{ minHeight: '55px' }}>
                      {placaversions.length === 0 && (
                        <span className='text-muted'>No hay versiones de placa creadas</span>
                      )}

                      {placaversions.map((placa) => (
                        <Form.Check
                          key={placa.id}
                          inline
                          type='checkbox'
                          label={placa.version}
                          checked={(firm.placaversions || []).some((p) => p.id === placa.id)}
                          onChange={() => toggleAvailableFirmwarePlacaversion(firm.id, placa)}
                        />
                      ))}
                    </div>
                  </Col>
                  <Col xs={12} md={2}>
                    <strong>{t('mandatory')}</strong>
                    <Form.Check
                      type='checkbox'
                      checked={firm.mandatory || false}
                      onChange={(e) =>
                        updateFirmwareField(
                          firm.id,
                          'mandatory',
                          e.target.checked
                        )
                      }
                    />
                  </Col>

                  <Col xs={12} md={3}>
                    <strong>checksum</strong>
                    <Form.Control
                      value={firm.checksum || ''}
                      onChange={(e) =>
                        updateFirmwareField(
                          firm.id,
                          'checksum',
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col xs={12} md={2}>
                    <strong>{t('sizebytes')}</strong>
                    <Form.Control
                      type='number'
                      value={firm.size_bytes || ''}
                      onChange={(e) =>
                        updateFirmwareField(
                          firm.id,
                          'size_bytes',
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col xs={12}>
                    <strong>{t('releaseNotes')}</strong>
                    <Form.Control
                      as='textarea'
                      rows={2}
                      value={firm.release_notes || ''}
                      onChange={(e) =>
                        updateFirmwareField(
                          firm.id,
                          'release_notes',
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col xs={12} md={1} className='d-grid mt-2 mt-md-4'>
                    <Button onClick={() => patchFirmware(firm)}>
                      {t('save')}
                    </Button>
                  </Col>

                  <Col xs={12} md={2} className='d-grid mt-2 mt-md-4'>
                    <Button
                      id='delUser'
                      className='dark'
                      onClick={() =>
                        window.confirm(t('delFirm')) ? delFirmware(firm.version) : null
                      }
                    >
                      {t('firmwareDel')}
                    </Button>
                  </Col>
                </Row>
              </React.Fragment>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default FirmwareManagement;
